<script>
import DeviceDetectionMixin from '@/mixins/DeviceDetectionMixin';

export default {
  name: "ProjectInfo",
  mixins: [DeviceDetectionMixin],
  props: ["data"],
  created() {},
  methods: {
    backToList() {
      this.$emit('redirectBackToList');
    }
  },
  computed: {
    projectInfos() {
      return this.data;
    }
  }
};
</script>
<template>
  <b-row>
    <b-overlay
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >
      <div class="row">
        <div class="col d-flex align-items-center">
          <div class="project-title font-size-16 fw-bold">商流情報</div>
        </div>
        <div class="col d-flex justify-content-end">
          <div class="mb-2">
            <b-button variant="primary" size="lg" @click="backToList()">
              <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
            </b-button>
          </div>
        </div>
      </div>
      <hr class="my-1" />
      <div :class="detectMobileDevice() ? `project-infos-mobile` : `project-infos row`">
        <div class="project-item col">
          <div>商流: </div>
          <div>{{ (projectInfos && projectInfos.case_name) || "" }}</div>
        </div>

        <div class="project-item col">
          <div>得意先略称：</div>
          <div>
            {{ (projectInfos && projectInfos.customer.name_abbreviated) || "" }}
          </div>
        </div>
        <div class="project-item col">
          <div>事業者略称：</div>
          <div>
            {{
              (projectInfos && projectInfos.discharger.name_abbreviated) || ""
            }}
          </div>
        </div>
        <div class="project-item col">
          <div>事業場略称：</div>
          <div>
            {{
              (projectInfos && projectInfos.discharger_site.name_abbreviated) ||
                ""
            }}
          </div>
        </div>
        <div class="project-item col">
          <div>請求先：</div>
          <div>
            {{
              (projectInfos &&
                projectInfos.customer &&
                projectInfos.customer.name
                ) ||
                ""
            }}
          </div>
        </div>
        <div class="project-item col">
          <div>担当営業：</div>
          <div>
            {{
              (projectInfos &&
                projectInfos.discharger_site &&
                projectInfos.discharger_site.user1 &&
                projectInfos.discharger_site.user1.user_name
                ) ||
                ""
            }}
          </div>
        </div>
        <div class="project-item col">
          <div>連絡先：</div>
          <div>
            {{
              (projectInfos &&
                projectInfos.customer &&
                projectInfos.customer.user1 &&
                projectInfos.customer.user1.tel
                ) ||
                ""
            }}
          </div>
        </div>
      </div>
    </b-overlay>
  </b-row>
</template>
<style scoped lang="scss">
.project-infos {
  .project-item {
    font-size: 14px;
    color: #495057;
    font-weight: 600;
  }
}

.project-infos-mobile {
  gap: 10px;
  .project-item {
    display: flex;
    font-size: 14px;
    color: #495057;
    font-weight: 600;
    div:first-child {
      text-wrap: nowrap;
      margin-right: 8px;
    }
  }
}
</style>
